/* eslint-disable react/display-name */
import classNames from "classnames";
import React, { useContext } from "react";
import { NavigationContext } from "../contexts/NavigationContext";
import { CloseIcon } from "../icons/CloseIcon";
import { HamburgerIcon } from "../icons/HamburgerIcon";

export type DisplayWhen = "NAV_OPEN" | "NAV_CLOSED" | "BOTH";

interface Props {
  className?: string;
  displayWhen?: DisplayWhen;
}

export const NavigationToggleButton: React.FC<Props> = ({
  className = "",
  displayWhen = "BOTH",
}) => {
  const { toggleNavigation, isNavigationOpen } = useContext(NavigationContext);
  let displayClass = "block";
  if (
    (displayWhen == "NAV_OPEN" && !isNavigationOpen) ||
    (displayWhen == "NAV_CLOSED" && isNavigationOpen)
  ) {
    displayClass = "hidden";
  }
  return (
    <button
      aria-label={"Toggle Navigation"}
      onClick={toggleNavigation}
      className={classNames(className, displayClass)}
    >
      {isNavigationOpen ? <CloseIcon /> : <HamburgerIcon />}
    </button>
  );
};
